import { useEffect, useState } from 'react';

import { useStopwatch } from 'react-timer-hook';
import './index.less';
import { motion } from 'framer-motion';

/* type MyStopwatchListProps = {
    timeout: number,
    timeHandler: any,
    stopTime: boolean
};
 */

const MyCountDown = ({ timeout, timeHandler, stopTime }) => {
    const [expT, setExpT] = useState(0);

    useEffect(() => {

    }, []);

    useEffect(() => {
        if (stopTime && isRunning) pause();
        else if (!stopTime && !isRunning) start();
    }, [stopTime]);

    const {
        totalSeconds,
        seconds,
        minutes,
        hours,
        days,
        isRunning,
        start,
        pause,
        reset,
    } = useStopwatch({ autoStart: true });

    useEffect(() => {
        // console.log('MyCountDown minutes, seconds totalSeconds:', minutes, seconds, totalSeconds);
        if (totalSeconds >= timeout) {
            pause();
            timeHandler(timeout);
        }
    }, [totalSeconds]);

    const remSeconds = timeout - totalSeconds;

    if (remSeconds) return (
        <section className="timer countdown">
            <div>
                <motion.div
                    animate={{ scale: 2 }}
                    transition={{ duration: 0.5 }}
                    className="the-number"
                    key={remSeconds}
                >
                    <span>{remSeconds}</span>
                </motion.div>
            </div>
        </section >
    );
    else return null;
};
export default MyCountDown;
